import { IPage } from "./models";

export const appConfig: {
  settings: {
    [key: string]: any;
  };
  pages: {
    [key: string]: IPage
  };
  getNetworkType: (networkType: string) => { [key: string]: any };
  getHealthStatus: (healthStatus: string) => { [key: string]: any };
  getInstallStatus: (installStatus: string) => { [key: string]: any };
  getRssiStatus: (rssi: number) => { [key: string]: any } | null;
  getBatteryStatus: (voltage: number) => { [key: string]: any };
  msgs: {
    [key: string]: string;
  }
} = {
  settings: {
    pipApiBase: process.env.REACT_APP_PIP_SERVER_API_BASE || 'https://api.pipiotservices.com/api',
    mapDefaultCoordinate: { lat: -33.869982700307744, lng: 151.20808114793303 },
    googleMapApiKey: 'AIzaSyAGLZu-BV_pnFSYFpwtVuU3ko5c9mA2JDU',
    fetchRecentEventsMins: 30,
    testPayloadCount: 10,
    maxEventsPerRequest: 2000,
  },
  pages: {
    customers: {
      title: 'Customers',
      key: 'customers',
      url: '/customers',
    },
    devices: {
      title: 'Devices',
      key: 'devices',
      url: '/devices',
    },
    events: {
      title: 'Events',
      key: 'events',
      url: '/events',
    },
    installDevice: {
      title: 'Install Device',
      key: 'install_device',
      url: '/device/install',
    },
  },
  getNetworkType: (networkType: string) => {
    if (networkType === 'Sigfox') return { color: 'purple' };
    else if (networkType === 'LoRaWAN') return { color: 'blue' };
    else if (networkType === 'NBIOT') return { color: 'cyan' };
    else return { color: 'grey', text: 'Unknown' };
  },
  getHealthStatus: (healthStatus: string) => {
    if (healthStatus === 'Healthy') return { color: 'green', icon: 'CheckCircleOutlined' };
    if (healthStatus === 'Warning') return { color: 'orange', icon: 'ExclamationCircleOutlined' };
    return { color: 'red', icon: 'CloseCircleOutlined' };
  },
  getInstallStatus: (installStatus: string) => {
    if (installStatus === 'Installed') return { color: 'green', icon: 'CheckCircleOutlined' };
    if (installStatus === 'New') return { color: 'red', icon: 'ExclamationCircleOutlined' };
    return { color: 'grey' };
  },
  getRssiStatus: (rssi: number) => {
    if (!rssi) return null;
    if (rssi >= -114) return { color: 'green', text: 'Excellent' };
    if (rssi >= -127) return { color: 'green', text: 'Good' };
    if (rssi >= -130) return { color: 'yellow', text: 'Weak' };
    return { color: 'red', text: 'Critically Weak' };
  },
  getBatteryStatus: (voltage: number) => {
    if (voltage === undefined || voltage === null) return { color: 'grey', text: 'N/A' };
    if (voltage >= 6.5) return { color: 'green', text: 'Good' };
    if (voltage >= 6.0) return { color: 'yellow', text: 'Medium' };
    return { color: 'red', text: 'Poor' };
  },
  msgs: {
    testModeTip: 'Apply magnet to device for 5-9 seconds to enter RSSI test mode, transmitting 10 events over 5 minutes. LED will flash 5 times in response to entering RSSI test mode successfully.',
    locationSearchTip: 'Assign a location to your device by selecting a map position, typing a GPS co-ordinate, or typing an address. Deselect the "Sync Address to Map" option to manually enter an address without changing the map pin location.',
    distanceTip: 'Distance from device to empty or full position of container. Empty distance should be greater than full distance. Leave blank if not applicable.',
    noDeviceFound: 'No device found',
    noSerialsInput: 'Please provide at least one valid serial number.',
    someInvalidSerials: 'Some serial numbers are invalid. Please review your input.',
    serialsInputPlaceholder: 'Enter device serials (8 digits, separated by commas, semicolons, spaces or line breaks), such as "12345678,23456789,34567890".',
    deactivationTip: 'The deactivation process may take some time. Please do not close this dialog while processing. After completion, copy the results to a file for your records.',
    deactivationResultTip: 'Devices marked as "Never activated" cannot be unsubscribed from Sigfox at this time. Please keep a record of these devices and periodically re-attempt deactivation to ensure they are not incurring a Sigfox charge.',
  }
};